import { Container } from "react-bootstrap";
import cn from "classnames";
import { Description, Form as FormComponent, Title } from "@/ui";

export const Form = ({ className, bgColor, textColor, title, titleColor, description, formClassName, form_id }) => {
  if (!form_id) {
    return null;
  }

  return (
    <section className={cn(className, bgColor, textColor)}>
      <Container>
        <div className={formClassName}>
          {title && <Title className={titleColor} title={title} />}
          {description && <Description description={description} />}
          <FormComponent formId={form_id} />
        </div>
      </Container>
    </section>
  );
};

export default Form;
